// const { JUE } = window;

export const mapAttrsHandlers = {
  latitude(val: number, mapInstance: LooseObject): void {
    const lng = mapInstance.getCenter().getLng();
    mapInstance.setCenter(new JUE.LatLng(val, lng));
  },
  longitude(val: number, mapInstance: LooseObject): void {
    const lat = mapInstance.getCenter().getLat();
    mapInstance.setCenter(new JUE.LatLng(lat, val));
  },
  zoom(val: number, mapInstance: LooseObject): void {
    mapInstance.setZoom(val);
  },
  rotation(val: number, mapInstance: LooseObject): void {
    mapInstance.setRotation(val);
  },
  pitch(val: number, mapInstance: LooseObject): void {
    mapInstance.setPitch(val);
  },
  scale(val: number, mapInstance: LooseObject): void {
    mapInstance.setScale(val);
  },
  draggable(val: boolean, mapInstance: LooseObject): void {
    mapInstance.setDraggable(val);
  },
  viewMode(val: string, mapInstance: LooseObject): void {
    mapInstance.setViewMode(val);
  },
  zoomRange(val: number[], mapInstance: LooseObject): void {
    mapInstance.setMinZoom(val[0]).setMaxZoom(val[1]);
  },
  offset(val: OffsetOption, mapInstance: LooseObject): void {
    mapInstance.setOffset(val);
  },
  mapStyleId(val: string, mapInstance: LooseObject): void {
    mapInstance.setMapStyleId(val);
  },
};

